import { render, staticRenderFns } from "./ConstestacoesConfirmar.vue?vue&type=template&id=75096530&"
import script from "./ConstestacoesConfirmar.vue?vue&type=script&lang=js&"
export * from "./ConstestacoesConfirmar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports